import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  flexbox,
  layout,
  space,
  color,
  typography,
  border,
  position,
} from 'styled-system';

const Layout = styled.div`
  display: flex;
  ${flexbox}
  ${layout}
  ${space}
  ${color}
  ${typography}
  ${border}
  ${position}
`;

const Flex = React.forwardRef((props, ref) => {
  const { children } = props;
  return (
    <Layout ref={ref} {...props}>
      {children}
    </Layout>
  );
});

Flex.propTypes = {
  children: PropTypes.node,
};

Flex.defaultProps = {
  children: null,
};

export default Flex;
